<template>
  <div class="skuurlmatchingmanager">
    <div class="commonpageheader">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{name: 'Subscription'}">订阅管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{name: 'ProductInfoList', params: {subid: query.subid}, query: { page: productinfopage }}">标准信息表</el-breadcrumb-item>
        <el-breadcrumb-item>商品匹配规则管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="filterbox">
      
      <div class="skuurlmatchselectgroup skuurlmatchselectgroupinfo">
        <el-form size="small" label-width="100px">
          
          <el-row>
            <el-col :span="16">
              <el-form-item label="订阅名称">{{baseinfo.TaskName}}</el-form-item>
            </el-col>
            <el-col :span="8" style="padding-left:25px;">
              <el-button size="small" type="primary" plain @click="goToResultConsole()">查看匹配结果</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><el-form-item label="TaskID">{{baseinfo.TaskID}}</el-form-item></el-col>
            <el-col :span="8"><el-form-item label="SKU常规检测价">{{skuinfo.price}}</el-form-item></el-col>
            <el-col :span="8"><el-form-item label="用戶SKUCode">{{skuinfo.skucode}}</el-form-item></el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="SKUID">{{ skuinfo.id }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="SKU名称">{{ skuinfo.productName }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="SKU描述">{{ skuinfo.descripition === 'undefined' ? '' : skuinfo.descripition }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="SKU系列">{{ skuinfo.series }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="SKU型号">{{ skuinfo.model }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="SKU参数">{{ skuinfo.specification }}</el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="满足下列">
            <el-row>
              <el-col :span="4" style="padding-right:10px;">
                <el-select :disabled="disabled3" v-model="ruleform.rulestatus" placeholder="选择条件" size="small" popper-class="smallselectoption">
                  <el-option
                    v-for="item in rulestatusoptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="rulechannels" 
                  filterable
                  multiple
                  collapse-tags
                  placeholder="请选择渠道"
                  size="small"
                  popper-class="smallselectoption">
                  <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-button 
                  style="width:100px; float: right;" 
                  type="warning" 
                  @click="copyRule()" 
                  :disabled="showcopybtn">
                  复制规则
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
      
      <div class="skuurlmatchselectgroup">

        <el-form size="small" label-width="100px">

          <el-form-item v-for="rulesitem in ruleform.rulegroup" :key="rulesitem.key">
            <el-row :gutter="10">
              <el-col :span="4">
                <el-select 
                  :disabled="disabled3"
                  v-model="rulesitem.field" 
                  placeholder="选择字段" 
                  size="small" 
                  popper-class="smallselectoption"
                  @change="changethisfield(rulesitem)"
                  >
                  <el-option
                    v-for="item in rulesfields"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select 
                  :disabled="disabled3" 
                  v-if="rulesitem.field !== 'Price'" 
                  v-model="rulesitem.status" 
                  placeholder="选择条件" 
                  size="small" 
                  popper-class="smallselectoption">
                  <el-option
                    v-for="item in rulestype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-button type="text" disabled v-if="rulesitem.field === 'Price'" v-model="rulesitem.status" style="width:100%;">价格区间</el-button>
              </el-col>
              <el-col :span="12">
                <input-tag :read-only="disabled3" :before-adding="trimTags" v-if="rulesitem.field !== 'Price'" placeholder="每输入一个关键词按回车确认" v-model="rulesitem.keywords"></input-tag>
                <el-input :disabled="disabled3" v-if="rulesitem.field === 'Price'" placeholder="按照这个格式，如：100-200" v-model="rulesitem.keywords[0]"></el-input>
              </el-col>
              <el-col :span="4">
                <el-button :disabled="disabled3" @click="deleteSelector(rulesitem)">删除</el-button>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item v-if="!disabled3">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-button :disabled="ruleprogress" type="primary" @click="addSelector()">增加条件</el-button>           
              </el-col>
              <el-col :span="8" style="text-align:right;">
                <el-button 
                  v-if="ruleform.rulegroup.length > 0" :disabled="ruleprogress" 
                  type="success" 
                  @click="addRule()"
                >
                  保存规则
                </el-button>
                <el-popconfirm 
                  v-if="ruleform.rulegroup.length === 0" 
                  confirm-button-text="确定" 
                  cancel-button-text="取消" 
                  title="确定删除全部规则吗？" 
                  @confirm="addRule()"
                >
                  <el-button style="margin-left:10px;" type="success" slot="reference">保存规则</el-button>
                </el-popconfirm>
                <el-button 
                  style="width:100px;" 
                  type="danger" 
                  @click="startnow()" 
                  :disabled="disabledbtn" 
                  :loading="startnowloading"
                >
                  {{ stattnowtxt }}<!-- 立即执行 -->
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="预览数据">
            <el-button class="matchbtn" :class="{isactivethisbtn: isactivethisbtn0}" @click="matchclick(0)">命中</el-button>  
            <el-button class="matchbtn" :class="{isactivethisbtn: isactivethisbtn1}" @click="matchclick(1)">未命中</el-button> 
          </el-form-item>
        </el-form>

      </div>

    </div>

    <div class="commontable">
      <div class="tablebox">
        <el-table
          :cell-style="getCellStyle"
          v-loading="loading"
          :data="tablelist"
          tooltip-effect="dark"
          size="small"
          @sort-change="sortthiscolumn"
          :default-sort="defaultsort"
          :empty-text="emptytext"
        >
          <el-table-column prop="AssetID" label="AssetID" width="120px" show-overflow-tooltip></el-table-column>
          <el-table-column show-overflow-tooltip label="商品标题">
            <template slot-scope="scope">
              <a :href="scope.row.AssetURL" target="_blank" v-html="scope.row.AssetTitle"></a>
            </template>
          </el-table-column>
          <el-table-column label="SKUMAP" width="400px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-html="scope.row.SkuMap"></span>
            </template>
          </el-table-column>
          <el-table-column prop="AssetContent" label="商品描述" width="150px" show-overflow-tooltip></el-table-column>
          <el-table-column sortable='custom' prop="Price" label="Price" width="100px"></el-table-column>
        </el-table>
      </div>

      <div class="table-pagination">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="query.size"
          layout="total, prev, pager, next, sizes"
          :total="totalbrand"
        ></el-pagination>
      </div>
      
    </div>

    <el-dialog
      title="复制规则"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="showcopydialog"
      width="500px">
      <div class="edit-form">
        <el-form size="mini">
          <el-form-item label="SKUID">
            <el-select v-model="copyskuid" filterable>
              <el-option v-for="item in rulelists" :key="item.skuid" :label="item.skuid" :value="item.skuid"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog()" size="small">取 消</el-button>
        <el-button :disabled="copyskuid == ''" type="primary" @click="confirmCopyRule()" size="small">确 定</el-button>
      </span>
    </el-dialog>  

  </div>
</template>

<script>
export default {
  data(){
    return{
      loading: false,
      defaultsort: {
        prop: 'Price',
        order: ''
      },
      poid: this.$route.params.poid,
      query: {
        subid: this.$route.params.subid,
        skuid: this.$route.params.skuid,
        page: 1,
        size: this.getLocalStorage('pagesize7') ? this.getLocalStorage('pagesize7') * 1 : 25,
        type: 1,
        order: ''
      },
      currentPage: 1,
      tablelist: [],
      totalbrand: 0,
      baseinfo: {},
      skuinfo: {},

      searchstatus: 0,
      
      rulestatusoptions: [{
        label: '所有条件',
        value: '所有条件'
      },{
        label: '任一条件',
        value: '任一条件'
      }],

      rulesfields: [{
        label: 'AssetTitle+SkuMap',
        value: 'AssetTitle+SkuMap'
      },{
        label: 'AssetTitle',
        value: 'AssetTitle'
      },{
        label: 'SkuMap',
        value: 'SkuMap'
      },{
        label: 'AssetContent',
        value: 'AssetContent'
      }
      // ,{
      //   label: 'Price',
      //   value: 'Price'
      // },{
      //   label: 'BrandName',
      //   value: 'BrandName'
      // }
      ],

      rulestype: [{
        label: '包含所有关键词',
        value: '包含所有关键词'
      },{
        label: '包含任一关键词',
        value: '包含任一关键词'
      },{
        label: '不包含任一关键词',
        value: '不包含任一关键词'
      }],

      channels: [],
      rulechannels: [],
      defaultchannels: [],

      ruleform: {
        rulestatus: '所有条件',
        rulegroup: [
          {
            field: 'AssetTitle+SkuMap',
            keywords: [],
            status: '包含所有关键词',
            key: Date.now()
          }
        ]
      },

      ruleid: 0,
      norule: true,

      isactivethisbtn0: false,
      isactivethisbtn1: false,

      startnowloading: false,
      disabledbtn: false,
      stattnowtxt: '立即执行',
      ruleprogress: false,
      timer: null,
      timerNum: 10,

      ruletemp: {},
      locktype: 0,
      ruleprogressstatus: 0,
      productinfopage: 0,
      
      highlightkeywords: [],
      disabled1: this.getLocalStorage('level')/1 === 1 ? true : false,
      disabled3: this.getLocalStorage('level')/1 === 3 ? true : false,
      emptytext: '',
      showcopybtn: true,
      showcopydialog: false,
      rulelists: [],
      copyskuid: '',

      // showcopy: window.btoa(this.getLocalStorage('account')) === 'ZGF2aWQubGl1QHNpbXBseWJyYW5kLmNvbQ=='
    }
  },

  mounted(){
    let that = this

    that.getChannel()
    that.getSkuRules()
    
    that.query.order = that.getLocalStorage('OrderSku') != undefined ? that.getLocalStorage('OrderSku') : ''
    if(that.query.order == 10){
      that.defaultsort.order = 'ascending'
    }
    if(that.query.order == 11){
      that.defaultsort.order = 'descending'
    }
    if(that.query.order == ''){
      that.defaultsort.order = null
    }
    that.productinfopage = JSON.parse(localStorage.getItem("currentpage")).val
    that.getBaseInfo()
    that.getSkuInfo()
    that.getRule(function(){
      if(that.norule === true){
        console.log('没有匹配规则')
        that.emptytext = '请先设置匹配规则'
        that.showcopybtn = false
        // that.disabledbtn = true
        // that.getResultList(that.query.type)
      }else{
        that.showcopybtn = true
        that.emptytext = '暂无数据'
        that.isactivethisbtn0 = true
        that.disabledbtn = false
        that.matchData(that.searchstatus)
      }
    })

  },

  methods: {

    getCellStyle({ column }) {
      // TODO 针对Safari表格width与showOverflowTooltip暂不能共存异常
      const tempWidth = column.realWidth || column.width
      if (column.showOverflowTooltip) {
        return {
          minWidth: tempWidth + 'px',
          maxWidth: tempWidth + 'px'
        }
      }

      return {}
    },


    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this
      that.currentPage = 1
      that.query.page = 1
      that.query.size = val
      that.setLocalStorage('pagesize7', val)

      let _ruleform = JSON.parse(JSON.stringify(that.ruleform))
      
      if(_ruleform.rulegroup.length === 1 && _ruleform.rulegroup[0].keywords.length === 0){
        that.getResultList(that.query.type)
      }else{
        that.matchData(that.searchstatus)
      }
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this
      that.query.page = val

      let _ruleform = JSON.parse(JSON.stringify(that.ruleform))
      
      if(_ruleform.rulegroup.length === 1 && _ruleform.rulegroup[0].keywords.length === 0){
        that.getResultList(that.query.type)
      }else{
        that.matchData(that.searchstatus)
      }
    },
    
    /**
     * 增加条件组
     */
    addSelector: function(){
      this.ruleform.rulegroup.push({
        field: 'AssetTitle+SkuMap',
        keywords: [],
        status: '包含所有关键词',
        key: Date.now()
      })
    },

    /**
     * 删除条件组
     */
    deleteSelector: function(item){
      var index = this.ruleform.rulegroup.indexOf(item)
      if (index !== -1) {
        this.ruleform.rulegroup.splice(index, 1)
      }     
    },

    /**
     * 获取数据list
     */
    getResultList: function(sts){
      let that = this
      that.query.type = sts/1
      let url = that.API_URL + '/sys/rule/list'
      let query = that.query
      that.loading = true
      that.tablelist = []
      that.emptytext = '暂无数据'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getResultList', data)
          that.totalbrand = data.results[0][0].Count
          let lists = data.results[1]
          lists.forEach(item => {
            item.AssetTitle = that.highlighted(that.highlightkeywords, item.AssetTitle)
            item.SkuMap = that.highlighted(that.highlightkeywords, item.SkuMap)
          })
          that.tablelist = lists
          that.loading = false
        },
        error: function(response) {
          console.log('getResultList', response)
        }
      })
    },

    /**
     * 获取SKU信息
     */
    getSkuInfo: function(){
      let that = this
      let url = that.API_URL + '/sys/monitor/view'
      let query = {skuid: that.query.skuid}
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getSkuInfo', data)
          that.skuinfo = data.results
        },
        error: function(response) {
          console.log('getSkuInfo', response)
        }
      })
    },
    
    /**
     * 获取订阅基本信息
     */
    getBaseInfo: function(){
      let that = this
      let url = that.API_URL + '/sys/match/view'
      let query = {subid: that.query.subid}
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getBaseInfo', data)
          let info = data.results[0]
          that.baseinfo = info
        },
        error: function(response) {
          console.log('getBaseInfo', response)
        }
      })
    },

    /**
     * 添加规则
     */
    addRule: function(){

      let that = this

      if(that.ruleform.rulestatus === ''){
        that.$message.error('请输入规则')
        return false
      }
      if(
        that.ruleform.rulegroup.length === 1 && (
        that.ruleform.rulegroup[0].filed === '' ||
        that.ruleform.rulegroup[0].keywords.length === 0
        )
      ){
        that.$message.error('请输入规则')
        return false
      }
      if(that.ruleform.rulegroup.length === 0){
        that.delAllRule()
        return false
      }

      let _ruleform = JSON.parse(JSON.stringify(that.ruleform))
      _ruleform.rulestatus = _ruleform.rulestatus === "所有条件" ? 0 : 1
      _ruleform.rulegroup.forEach(function(res){
        res.keywords = res.status === '' ? res.keywords.join('-').split('-') : res.keywords
        if(res.status === '包含所有关键词'){
          res.status = 0
        }
        if(res.status === "包含任一关键词"){
          res.status = 1
        }
        if(res.status === "不包含任一关键词"){
          res.status = 2
        }
        if(res.status === ""){
          res.status = 3
        }
      })
      let url = that.API_URL + '/sys/rule/edit'
      let query = {
        taskid: that.query.subid/1,
        skuid: that.query.skuid/1,
        ruleid: that.ruleid,
        channels: JSON.stringify(that.rulechannels),
        content: JSON.stringify(_ruleform)
      }
      if(JSON.stringify(_ruleform)==JSON.stringify(that.ruletemp)){
        that.$message.error('规则已保存成功，可修改后再次保存')
        return
      }
      let qc = _ruleform.rulegroup
      let qcount = qc.map(item => {
        return item.keywords.length === 0 ? 0 : 1
      })
      let checkkeywords = that.sumArr(qcount)
      if(checkkeywords/1 != qc.length){
        that.$message.error('关键词不能为空，请输入关键词')
        return
      }
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('addRule', data)
          that.$message.success('规则保存成功')
          that.disabledbtn = false
          that.showcopybtn = true
          that.ruletemp = _ruleform
          that.getRule(function(){

          })
        },
        error: function(response) {
          console.log('addRule', response)
        }
      })

    },

    sumArr: function(arr){
      return eval(arr.join("+"))
    },

    /**
     * 获取规则
     */
    getRule: function(callback){

      let that = this
      let url = that.API_URL + '/sys/rule/view'
      let query = {
        subid: that.query.subid,
        skuid: that.query.skuid
      }
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          // console.log('getRule1', data)
          let res = data.results
          if(res.length === 0){
            that.ruleid = 0
            that.norule = true
            that.rulechannels = that.defaultchannels
          }else{
            that.rulechannels = res[res.length-1].channels != null ? JSON.parse(res[res.length-1].channels) : that.defaultchannels
            let resc = res[res.length-1].rulecontent
            let resc0 = resc.substr(1)
            let resc1 = resc0.substr(0, resc0.length-1)
            let resc2 = JSON.parse(''+ resc1 +'')
            that.ruleform = resc2
            that.ruleform.rulestatus = resc2.rulestatus === 0 ? "所有条件" : "任一条件"
            that.ruleform.rulegroup.forEach(function(res){
              if(res.status === 0){
                res.status = '包含所有关键词'
              }
              if(res.status === 1){
                res.status = "包含任一关键词"
              }
              if(res.status === 2){
                res.status = "不包含任一关键词"
              }
              if(res.status === 3){
                let p = res.keywords.join("-")
                res.keywords = []
                res.keywords[0] = p
                res.status = ""
              }
            })
            that.ruleid = res[res.length-1].ruleid/1
            that.norule = false
            that.highlightkeywords = []
            for(let i=0; i<that.ruleform.rulegroup.length; i++){
              if(that.ruleform.rulegroup[i].status === '包含所有关键词' || that.ruleform.rulegroup[i].status === '包含任一关键词'){
                that.highlightkeywords.push(...that.ruleform.rulegroup[i].keywords)
              }
            }
            // console.log('getRule2', that.ruleform)
          }
          callback()
        },
        error: function(response) {
          console.log('getRule', response)
        }
      })

    },

    matchclick:function(sts){
      this.query.page = 1 
      this.currentPage = 1
      this.highlightkeywords = []
      console.log('matchclick', this.ruleform.rulegroup)
      for(let i=0; i<this.ruleform.rulegroup.length; i++){
        if(this.ruleform.rulegroup[i].status === '包含所有关键词' || this.ruleform.rulegroup[i].status === '包含任一关键词'){
          this.highlightkeywords.push(...this.ruleform.rulegroup[i].keywords)
        }
      }
      this.matchData(sts)
    },

    /**
     * 命中数据
     */
    matchData: function(sts){
      let that = this
      let _ruleform = JSON.parse(JSON.stringify(that.ruleform))
      that.emptytext = '暂无数据'
      if(_ruleform.rulegroup.length === 1 && _ruleform.rulegroup[0].keywords.length === 0){
        that.$message.error('请输入规则')
        return
      }
      if(_ruleform.rulegroup.length === 1 && _ruleform.rulegroup[0].field == ''){
        that.$message.error('请输入规则')
        return
      }
      if(_ruleform.rulegroup.length === 1 && _ruleform.rulegroup[0].status == ''){
        that.$message.error('请输入规则')
        return
      }
      if(_ruleform.rulestatus == ''){
        that.$message.error('请输入规则')
        return
      }
      _ruleform.rulestatus = _ruleform.rulestatus === "所有条件" ? 0 : 1
      _ruleform.searchstatus = sts/1
      that.searchstatus = sts/1
      _ruleform.rulegroup.forEach(function(res){
        res.keywords = res.status === '' ? res.keywords.join('-').split('-') : res.keywords
        if(res.status === '包含所有关键词'){
          res.status = 0
        }
        if(res.status === "包含任一关键词"){
          res.status = 1
        }
        if(res.status === "不包含任一关键词"){
          res.status = 2
        }
        if(res.status === ""){
          res.status = 3
        }
      })
      let query = {
        subid: that.query.subid/1,
        rule: JSON.stringify(_ruleform),
        page: that.query.page,
        size: that.query.size,
        channels: JSON.stringify(that.rulechannels),
        order: that.query.order
      }
      let url = that.API_URL + '/sys/rule/match'
      that.loading = true
      that.tablelist = []

      if(sts === 0){
        that.isactivethisbtn0 = true
        that.isactivethisbtn1 = false
      }else{
        that.isactivethisbtn0 = false
        that.isactivethisbtn1 = true       
      }
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('matchData', data)
          that.totalbrand = data.results[0][0].Count
          let lists = data.results[1]
          lists.forEach(item => {
            item.AssetTitle = that.highlighted(that.highlightkeywords, item.AssetTitle)
            item.SkuMap = that.highlighted(that.highlightkeywords, item.SkuMap)
          })
          that.tablelist = lists
          that.loading = false
        },
        error: function(response) {
          console.log('matchData', response)
        }
      })
    },

    /**
     * 切换字段
     */
    changethisfield: function(item){
      item.keywords = []
      item.status = ''
    },

    /**
     * 立即执行
     */
    startnow: function(){
      let that = this
      that.startnowloading = true
      that.disabledbtn = true
      that.ruleprogress = true
      //that.stattnowtxt = '执行中'
      //that.$message.success('规则执行中，请耐心等待')
      //that.$message.success('规则执行成功，请查看结果')
      that.activeCurrentRule()
      //that.getStatus()
    },

    /**
     * 定时器操作
     */
    getStatus() {
      this.loadingtimer()
      this.timer = setInterval(() => {
        if (this.ruleprogressstatus === 2) {
          /**
           * 获取状态，如果状态改变就停止执行定时器
           */
          this.timer && this.clearTimer()
          this.ruleprogressstatus = 0
          this.startnowloading = false
          this.disabledbtn = false
          this.ruleprogress = false
          this.stattnowtxt = '立即执行'
          this.$message.success('规则执行成功，请查看结果')
        } else {
          /**
           * 持续执行定时器，直到状态改变
           */
          this.loadingtimer()
        }
      }, 60000)
    },

    /**
     * 执行定时器
     */
    loadingtimer() {
      this.getRuleStatus()
    },

    /**
     * 清除定时器
     */
    clearTimer() {
      clearInterval(this.timer)
      this.timer = null
    },

    /**
     * 跳转至匹配结果页
     */
    goToResultConsole: function(){
      let that = this
      that.$router.push({name: 'MatchResultConsole',params: {subid: that.$route.params.subid, poid: that.$route.params.poid, skuid: that.$route.params.skuid}})
    },

    /**
     * 获取当前规则的运行状态
     */
    getRuleStatus: function(){
      let that = this
      let url = that.API_URL + '/sys/rule/status'
      let query = {skuid: that.query.skuid}
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getRuleStatus', data)
          if(data.results.length>0){
            that.ruleprogressstatus = data.results[0].status
          }
        },
        error: function(response) {
          console.log('getRuleStatus', response)
        }
      })
    },
    getRuleStatusOnce: function(){
      let that = this
      let url = that.API_URL + '/sys/rule/status'
      let query = {skuid: that.query.skuid}
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getRuleStatus', data)
          if(data.results.length>0){
            that.ruleprogressstatus = data.results[0].status
            if(that.ruleprogressstatus === 1){
              that.startnowloading = true
              that.disabledbtn = true
              that.ruleprogress = true
              that.stattnowtxt = '执行中'
              that.$message.success('规则执行中，请耐心等待')
              that.getStatus()
            }
            if(that.ruleprogressstatus === 2){
              that.disabledbtn = true
              that.stattnowtxt = '立即执行'
              that.$message.success('规则执行成功，请查看结果')
            }
          }
        },
        error: function(response) {
          console.log('getRuleStatus', response)
        }
      })
    },

    /**
     * 立即执行当前规则
     */
    activeCurrentRule: function(){
      let that = this
      let url = that.API_URL + '/sys/rule/active'
      let query = {skuid: that.query.skuid, ruleid: that.ruleid}
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          that.$message.success('规则执行成功，请查看结果')
          that.startnowloading = false
          that.disabledbtn = false
          that.ruleprogress = false
          that.matchData(0)
          console.log('activeCurrentRule', data)
        },
        error: function(response) {
          console.log('activeCurrentRule', response)
        }
      })
    },

    /**
     * 去除空格
     */
    trimTags: function(obj){
      return $.trim(obj)
    },

    /**
     * 删除规则
     */
    delAllRule: function(){
      let that = this
      let url = that.API_URL + '/sys/rule/del'
      let query = {ruleid: that.ruleid}
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('delAllRule', data)
          that.$message.success('规则删除成功，请刷新页面')
          that.getResultList(that.query.type)
        },
        error: function(response) {
          console.log('delAllRule', response)
          that.$message.success('规则删除失败，请重试')
        }
      })
    },

    /**
     * Price 排序
     */
    sortthiscolumn: function(column){
      let that = this
      if(column.prop == "Price" && column.order == "ascending"){
        that.query.order = 10
        let _ruleform = JSON.parse(JSON.stringify(that.ruleform))
        if(_ruleform.rulegroup.length === 1 && _ruleform.rulegroup[0].keywords.length === 0){
          that.getResultList(that.query.type)
        }else{
          that.matchData(that.searchstatus)
        }
        that.setLocalStorage('OrderSku', 10)
      }else if(column.prop == "Price" && column.order == "descending"){
        that.query.order = 11
        let _ruleform = JSON.parse(JSON.stringify(that.ruleform))
        if(_ruleform.rulegroup.length === 1 && _ruleform.rulegroup[0].keywords.length === 0){
          that.getResultList(that.query.type)
        }else{
          that.matchData(that.searchstatus)
        }
        that.setLocalStorage('OrderSku', 11)
      }else if(column.prop == "Price" && column.order == null){
        that.query.order = ''
        let _ruleform = JSON.parse(JSON.stringify(that.ruleform))
        if(_ruleform.rulegroup.length === 1 && _ruleform.rulegroup[0].keywords.length === 0){
          that.getResultList(that.query.type)
        }else{
          that.matchData(that.searchstatus)
        }
        that.setLocalStorage('OrderSku', '')
      }else{
        return
      }
    },

    /**
     * 获取全部sku规则
     */
    getSkuRules: function(){
      let that = this
      let url = that.API_URL + '/sys/rule/getRule?subid=' + that.query.subid/1
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(res) {
          that.rulelists = res.results
        },
        error: function(err) {
          console.log('getSkuRules', err)
        }
      })
    },

    copyRule: function(){
      this.showcopydialog = true
    },

    cancelDialog: function(){
      this.showcopydialog = false
      this.copyskuid = ''
    },

    /**
     * 复制规则
     */
    confirmCopyRule: function(){
      let that = this
      let res = ''
      for(let i=0; i<that.rulelists.length; i++){
        if(that.rulelists[i].skuid == that.copyskuid){
          res = that.rulelists[i]
        }
      }
      
      let resc = res.rulecontent
        let resc0 = resc.substr(1)
        let resc1 = resc0.substr(0, resc0.length-1)
        let resc2 = JSON.parse(''+ resc1 +'')
        that.ruleform = resc2
        that.ruleform.rulestatus = resc2.rulestatus === 0 ? "所有条件" : "任一条件"
        that.ruleform.rulegroup.forEach(function(res){
          if(res.status === 0){
            res.status = '包含所有关键词'
          }
          if(res.status === 1){
            res.status = "包含任一关键词"
          }
          if(res.status === 2){
            res.status = "不包含任一关键词"
          }
          if(res.status === 3){
            let p = res.keywords.join("-")
            res.keywords = []
            res.keywords[0] = p
            res.status = ""
          }
        })
        console.log(res)
        that.ruleid = 0
        that.norule = false
        that.rulechannels = JSON.parse(res.channels)
        that.highlightkeywords = []
        for(let i=0; i<that.ruleform.rulegroup.length; i++){
          if(that.ruleform.rulegroup[i].status === '包含所有关键词' || that.ruleform.rulegroup[i].status === '包含任一关键词'){
            that.highlightkeywords.push(...that.ruleform.rulegroup[i].keywords)
          }
        }
        that.copyskuid = ''
        that.showcopydialog = false
    },

    /**
     * 获取渠道列表
     */
    getChannel: function(){
      let that = this
      let url = that.API_URL + '/sys/match/getChannel?subid=' + that.poid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          let _cid = data.results[0].channel.split(',')
          let _cname = data.results[0].channelname.split(',')
          let _channel = []
          let _defaultchannels = []
          for(let i=0; i<_cid.length; i++){
            let _obj = {
              label: _cname[i],
              value: _cid[i] * 1
            }
            _channel.push(_obj)
            _defaultchannels.push(_cid[i] * 1)
          }
          that.channels = _channel
          that.defaultchannels = _defaultchannels
        },
        error: function(response) {
          console.log('getChannel', response)
        }
      })
    },

  },

  /**
   * 离开页面销毁定时器
   */
  // beforeDestroy() {
  //   clearInterval(this.timer) 
  //   this.timer = null
  // }

}
</script>
